import { render } from "./BuyTokenModal.vue?vue&type=template&id=252de849"
import script from "./BuyTokenModal.vue?vue&type=script&lang=ts"
export * from "./BuyTokenModal.vue?vue&type=script&lang=ts"
script.render = render

export default script